import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const deliveryAddCostTypeDict: Array<Dictionary> = []

enum deliveryAddCostTypes {
    FIXED_SUM = 'fixed_sum',
    PERCENT = 'percent'
}

for (const code of Object.values(deliveryAddCostTypes)) {
    deliveryAddCostTypeDict.push(
        {
            code,
            name: i18n.t(`dictionary.deliveryAddCostType.${code}`).toString()
        }
    )
}

export { deliveryAddCostTypes, deliveryAddCostTypeDict }
